/*
 *
 * These are auto-generated from react-query-sdk
 * However, we're referencing them here because of orval's inability to consolidate typings in a DRY way.
 *
 */

const ErrorCodes = {
  AuthLoginError: 'AuthLoginError',
  UnauthorizedError: 'UnauthorizedError',
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;

export { ErrorCodes };
